<template>
  <div id="timer">
    <v-row class="pl-3 justify-start">
      <p class="white--text font-weight-bold text-h3">INGAME TIMER</p>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard
          :image="
            isDay
              ? `https://community.blackdesertonline.com/index.php?media/elders-bridge-pass.8790/full&d=1519513673`
              : `https://community.blackdesertonline.com/index.php?media/night-in-the-bree-forest.8104/full&d=1515788790`
          "
          text="Current Time"
          :time="displayHour + `:` + displayMinute + ampm"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard
          :time="isDay ? displayNightStart : displayNightEnd"
          :text="isDay ? `until night-time` : `until day-time`"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard :time="displayDailyReset" text="Daily reset" />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard
          image="https://cdn.discordapp.com/attachments/666228815785230359/754832957302112276/unknown.png"
          :time="displayBoardgameReset"
          text="Boardgame reset"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard
          image="https://cdn.discordapp.com/attachments/666228815785230359/754833014261022720/2020-09-14_136802127.PNG"
          :time="displayImperialReset"
          text="Imperial reset"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <TimerCard
          image="https://vignette.wikia.nocookie.net/blackdesert/images/3/39/Vehicle_shabby_wagon.jpg/revision/latest?cb=20161023171845"
          :time="displayTradeReset"
          text="Trade reset"
        />
      </v-col>
    </v-row>
    <v-row class="pl-3 justify-start">
      <p class="white--text font-weight-bold text-h3">BOSS TIMER</p>
    </v-row>
  </div>
</template>

<script>
import TimerCard from "@/components/TimerCard.vue";
import axios from "axios";

export default {
  name: "Timers",
  components: {
    TimerCard
  },
  data() {
    return {
      isDay: false,
      inGameHour: 0,
      inGameMinute: 0,
      secsUntilNightStart: 0,
      secsUntilNightEnd: 0,
      secsUntilDailyReset: 0,
      secsUntilImperialReset: 0,
      secsUntilTradeReset: 0,
      secsUntilBoardgameReset: 0,
      bossTimes: [],
      upcomingBossTimes: []
    };
  },

  mounted() {
    this.getBossTimes();
    let baseTick = 4444.444444;
    setInterval(this.updateClockActive, baseTick);
    setInterval(this.updateClock, baseTick * 6);
    setInterval(this.updateCountdowns, 20 * 1000);
    this.updateClock();
    this.updateCountdowns();
  },

  methods: {
    updateCountdowns: function() {
      var d = new Date();
      var startHour = Date.UTC(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate(),
        0,
        0,
        0,
        0
      );
      var rlDayElapsedS = (Date.now() - startHour) / 1000;

      // Midnight UTC
      this.secsUntilDailyReset = 24 * 60 * 60 - rlDayElapsedS;

      // Imperial cooking/alchemy reset is every 3 hours from reset
      this.secsUntilImperialReset =
        3 * 60 * 60 - (rlDayElapsedS % (60 * 60 * 3));

      // Imperial delivery (trade) reset is every 4 hours from reset
      this.secsUntilTradeReset = 4 * 60 * 60 - (rlDayElapsedS % (60 * 60 * 4));

      // Jumani board game reset is at 5am UTC
      this.secsUntilBoardgameReset =
        60 * 60 * 24 - ((rlDayElapsedS - 5 * 60 * 60) % (60 * 60 * 24));
      if (this.secsUntilBoardgameReset > 60 * 60 * 24) {
        this.secsUntilBoardgameReset -= 60 * 60 * 24;
      }
    },

    // This version gets called far more often but doesn't update if
    // the site is not the active tab (using HTML page visibility api)
    updateClockActive: function() {
      if (document.hidden) {
        return;
      }
      this.updateClock();
    },

    updateClock: function() {
      var d = new Date();
      var startHour = Date.UTC(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate(),
        0,
        0,
        0,
        0
      );
      var rlDayElapsedS = (Date.now() - startHour) / 1000;
      var secsIntoGameDay = (rlDayElapsedS + 200 * 60 + 20 * 60) % (240 * 60);

      // Last part of the shifted day is night
      if (secsIntoGameDay >= 12000) {
        var secsIntoGameNight = secsIntoGameDay - 12000;
        var pctOfNightDone = secsIntoGameNight / (40 * 60);
        var gameHour = 9 * pctOfNightDone;
        gameHour = gameHour < 2 ? 22 + gameHour : gameHour - 2;
        var secsUntilNightEnd = 40 * 60 - secsIntoGameNight;

        this.isDay = false;
        this.inGameHour = (gameHour / 1) >> 0;
        this.inGameMinute = ((gameHour % 1) * 60) >> 0;
        this.secsUntilNightEnd = secsUntilNightEnd;
        this.secsUntilNightStart = secsUntilNightEnd + 12000;
      } else {
        var secsIntoGameDaytime = secsIntoGameDay;
        var pctOfDayDone = secsIntoGameDay / (200 * 60);
        gameHour = 7 + (22 - 7) * pctOfDayDone;
        var secsUntilNightStart = 12000 - secsIntoGameDaytime;

        this.isDay = true;
        this.inGameHour = (gameHour / 1) >> 0;
        this.inGameMinute = ((gameHour % 1) * 60) >> 0;
        this.secsUntilNightEnd = secsUntilNightStart + 40 * 60;
        this.secsUntilNightStart = secsUntilNightStart;
      }

      this.bossTimes.forEach(function(element, index, array) {
        if (
          d.getTime() <= element.time &&
          d.getTime() > array[index - 1].time
        ) {
          this.upcomingBossTimes = [element, array[index + 1]];
        }
      });
    },
    calculateClocktime(secs) {
      if (secs < 60) {
        return "<1 min";
      } else if (secs < 60 * 60) {
        return ((secs / 60) >> 0) + "m";
      } else {
        return ((secs / 3600) >> 0) + "h" + (((secs % 3600) / 60) >> 0) + "m";
      }
    },
    getBossTimes() {
      axios
        .get("https://warflash.live/api/boss?region=" + "TODO")
        .then(response => (this.bossTimes = response.data));
    }
  },

  computed: {
    ampm() {
      return this.inGameHour < 12 ? "AM" : "PM";
    },
    displayHour() {
      var t = this.inGameHour % 12;
      if (t === 0) {
        t = 12;
      }
      return this.inGameHour > 0 && this.inGameHour < 10 ? "0" + +t : t;
    },
    displayMinute() {
      return this.inGameMinute < 10
        ? "0" + +this.inGameMinute
        : this.inGameMinute;
    },
    displayNightStart() {
      return this.calculateClocktime(this.secsUntilNightStart);
    },
    displayNightEnd() {
      return this.calculateClocktime(this.secsUntilNightEnd);
    },
    displayDailyReset() {
      return this.calculateClocktime(this.secsUntilDailyReset);
    },
    displayImperialReset() {
      return this.calculateClocktime(this.secsUntilImperialReset);
    },
    displayTradeReset() {
      return this.calculateClocktime(this.secsUntilTradeReset);
    },
    displayBoardgameReset() {
      return this.calculateClocktime(this.secsUntilBoardgameReset);
    }
  }
};
</script>